// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { LimitOrderType } from "./order-type/LimitOrderType.js";
import { MarketOrderType } from "./order-type/MarketOrderType.js";
import { OCOOrderType } from "./order-type/OCOOrderType.js";
import { StopLimitOrderType } from "./order-type/StopLimitOrderType.js";
import { StopOrderType } from "./order-type/StopOrderType.js";
import { TrailingStopOrderType } from "./order-type/TrailingStopOrderType.js";

// класс который содержит в себе дополнительные параметры ордeра
export let OrderParamsContainer = function ()
{
    this.OrderTypes = {}

    this.AddOrderType(new MarketOrderType());
    this.AddOrderType(new LimitOrderType());
    this.AddOrderType(new StopOrderType());
    this.AddOrderType(new StopLimitOrderType());
    this.AddOrderType(new TrailingStopOrderType());
    this.AddOrderType(new OCOOrderType());
}

OrderParamsContainer.prototype.AddOrderType = function (orderType)
{
    this.OrderTypes[orderType.id()] = orderType
}

// TODO. OrderExecutor's constants dependent.
OrderParamsContainer.prototype.GetOrderType = function (id)
{
    return this.OrderTypes[id]
}
